export default __webpack_public_path__ + "static/media/Portals.8805105a.svg";